import { useState } from "react";
import type { CSSProperties } from "react";
import logoOfficialSrc from "../../assets/logo-official.svg";

interface ImageWithFallbackProps {
  src?: string | null | undefined;
  alt: string;
  className?: string | undefined;
  style?: CSSProperties | undefined;
}

function proxied(src: string): string {
  // Only proxy absolute remote http(s) URLs through wsrv.nl (resize + webp).
  if (!/^https?:\/\//i.test(src)) return src;
  return `https://wsrv.nl/?url=${encodeURIComponent(src)}&w=720&output=webp&q=78`;
}

export default function ImageWithFallback({ src, alt, className, style }: ImageWithFallbackProps) {
  const [stage, setStage] = useState<0 | 1 | 2>(0);

  const isLogo = !!src && (/\.svg(\?|$)/i.test(src) || /logonew/i.test(src));
  const showFallback = !src || isLogo || stage === 2;

  if (showFallback) {
    return (
      <div
        className={className}
        style={{
          background: "var(--brand-graphite, #313131)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          minHeight: 160,
          ...style,
        }}
      >
        <img
          src={logoOfficialSrc}
          alt=""
          aria-hidden="true"
          style={{ width: 64, height: 64, objectFit: "contain", opacity: 0.3 }}
        />
      </div>
    );
  }

  return (
    <img
      src={stage === 0 ? proxied(src!) : src!}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={className}
      style={{
        display: "block",
        width: "100%",
        height: "auto",
        objectFit: "contain",
        ...style,
      }}
      onError={() => setStage((s) => (s + 1) as 0 | 1 | 2)}
    />
  );
}
